import { useEffect } from 'react';

const HeaderManager = () => {
  useEffect(() => {
    const handleScroll = () => {
      const videoSections = document.querySelector('.content');
      const stickyHeader = document.querySelector('.header-sticky');
      const videoHeader = document.querySelector('.header-video');
      
      if (!videoSections || !stickyHeader || !videoHeader) return;
      
      // Check if mobile (screen width <= 768px)
      const isMobile = window.innerWidth <= 768;
      
      if (isMobile) {
        // On mobile: hide sticky header, keep video header visible
        stickyHeader.classList.remove('visible');
        stickyHeader.style.display = 'none';
        videoHeader.style.opacity = '1';
        return;
      }
      
      // Desktop behavior
      const videoEnd = videoSections.getBoundingClientRect().bottom;
      
      if (videoEnd <= 0) {
        stickyHeader.classList.add('visible');
        stickyHeader.style.display = 'block';
        videoHeader.style.opacity = '0';
      } else {
        stickyHeader.classList.remove('visible');
        stickyHeader.style.display = 'block';
        videoHeader.style.opacity = '1';
      }
    };

    // Run on mount and on resize
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll(); // Check on mount
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return null;
};

export default HeaderManager;